// mui
import { Box, Divider } from '@mui/material';

// components
import { Flexbox } from '../../../../../../components/layout/Flexbox';

// utils
import { PolicyDrawerTypography as Typography } from '../policy-details.utils';
import { useCowbellTranslations } from '../../../../../../i18n/translations';
import type { PolicyTableInfoDto } from '../../../../../../types/policy/tables/policy-table-info.dto';
import { REDACTED_FIELD } from '../../../../../../config/logrocket';

interface Props {
  policy: PolicyTableInfoDto;
}

export const OrganizationBroker = ({ policy }: Props) => {
  const { t } = useCowbellTranslations();

  // When there's a processed BOR, show current agent info from brokerOfRecord
  // Otherwise, show original agent info
  const hasProcessedBOR = policy.isBOR && policy.brokerOfRecord;
  const currentAgentInfo = hasProcessedBOR
    ? {
        agencyName: policy.brokerOfRecord.agencyName,
        agentFirstName: policy.brokerOfRecord.agentFirstName,
        agentLastName: policy.brokerOfRecord.agentLastName,
        agentEmail: policy.brokerOfRecord.agentEmail,
      }
    : {
        agencyName: policy.agencyName,
        agentFirstName: policy.agentFirstName,
        agentLastName: policy.agentLastName,
        agentEmail: policy.agentEmail,
      };

  return (
    <>
      <Box>
        <Typography variant="subtitle2" color="primary">
          {t('agent').toUpperCase()} INFO
        </Typography>
      </Box>
      <Divider style={{ width: '100%', margin: '0.5rem 0 1rem 0' }} />
      <Box display="flex">
        <Box width="100%">
          <Flexbox>
            <Typography>{t('agency')}</Typography>
            <Box className={REDACTED_FIELD}>
              <Typography>{currentAgentInfo.agencyName}</Typography>
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>{t('agent')} Name</Typography>
            <Box className={REDACTED_FIELD}>
              <Typography>{`${currentAgentInfo.agentFirstName} ${currentAgentInfo.agentLastName}`}</Typography>
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>{t('agent')} Email</Typography>
            <Box className={REDACTED_FIELD}>
              <Typography
                component="a"
                href={`mailto:${currentAgentInfo.agentEmail}`}
                className="link-underlined--hover"
              >
                {currentAgentInfo.agentEmail}
              </Typography>
            </Box>
          </Flexbox>
        </Box>
      </Box>
    </>
  );
};
